import {
  TextInput,
  TextInputProps,
  useListContext,
  useRedirect,
} from 'react-admin';
import { UUID_REGEX } from '../../utils/regex';

export const IDSearch: React.FC<TextInputProps> = (props) => {
  const redirect = useRedirect();
  const { resource } = useListContext();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (UUID_REGEX.test(value)) {
      redirect(`/${resource}/${value}/show`);
    }
  };

  return <TextInput onChange={handleChange} {...props} />;
};
